export const sendMetrik = (action) => {
    if(typeof window !== "undefined" && typeof window.ym !== undefined) {
        window.ym(100176158, "reachGoal", action);
    }
}